import { connect } from 'react-redux';

import { deleteById, Entities, fetchAll, fetchByCompanyId, getEntities, save, search } from 'src/common/index';
import SeasonCalculationAdministration from 'src/components/administration/season-calculation-administration';

const mapStateToProps = state => {
    return {
        selectedCompany: state.selectedCompany,
        seasonCalculations: getEntities(state, Entities.SEASON_CALCULATION, state.selectedCompany),
        tripCompanies: getEntities(state, Entities.TRIP_COMPANY),
    };
};

const SeasonCalculationAdministrationContainer = connect(mapStateToProps, {
    fetchByCompanyId,
    save,
    search,
    fetchAll,
    deleteById,
})(SeasonCalculationAdministration);

export default SeasonCalculationAdministrationContainer;
